import { render, staticRenderFns } from "./MarkingDetailsModal.vue?vue&type=template&id=012a2e61&scoped=true"
import script from "./MarkingDetailsModal.vue?vue&type=script&lang=js"
export * from "./MarkingDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./MarkingDetailsModal.vue?vue&type=style&index=0&id=012a2e61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012a2e61",
  null
  
)

export default component.exports